export default defineNuxtPlugin({
  name: 'device-init',
  dependsOn: ['pinia'],
  hooks: {
    // You can directly register Nuxt app runtime hooks here
    'app:mounted'() {
      const system = useSystemStore();
      system.addNetworkStatusListener();
      system.loadNetworkStatus();
    },
    // Unmounted? system.removeNetworkStatusListener();
  },
  // env: { islands: false }
})
